
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guestbooking/bookinglist",
      function () {
        return require("private-next-pages/guestbooking/bookinglist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guestbooking/bookinglist"])
      });
    }
  